import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var Container = /*#__PURE__*/function () {
  function Container(x) {
    _classCallCheck(this, Container);
    this.$value = x;
  }
  _createClass(Container, [{
    key: "call",
    value: function call(f) {
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      return this.$value = f.apply(void 0, [this.$value].concat(rest)), this;
    }
  }, {
    key: "value",
    value: function value() {
      return this.$value;
    }
  }], [{
    key: "of",
    value: function of(x) {
      return new Container(x);
    }
  }]);
  return Container;
}();
export { Container };